import isPast from 'date-fns/is_past';
import React from 'react';

import styles from '../style.scss';


const DateView = ({ date, payedTill }) => (
  <div className={styles.dateWrapper}>
    <div className={styles.date}>{date}</div>
    {!isPast(payedTill) &&
    <div className={styles.datePill}>Активная</div>
    }
  </div>
);

export default DateView;
